import React, { useEffect, useState } from 'react'
import { Autocomplete, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Radio, RadioGroup, TextField, Tooltip, Typography } from '@mui/material'
import { regexConstants } from '../../../constants/regEx'
import { color } from 'echarts';
import { CoPresentOutlined, Label } from '@mui/icons-material';
import { globalGetService, globalPostService, globalPutService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { enqueueSnackbar } from 'notistack';
import { additionalTaxTypeApi } from '../apiService';
import { trackActivity } from '../../../utils/mixpanel';
const invoiceTypeOptions = [
    { label: 'Reserve', value: 1 },
    { label: 'Rental', value: 2 },
    { label: 'Penalty', value: 3 },
    { label: 'Debit', value: 4 },
    { label: 'Credit', value: 5 },
    { label: 'Adhoc', value: 9 },
    { label: 'Security Deposit', value: 6 },
    // { label: 'Management Fee', value: 10 },
];
const managementFeeValue = 10;
const regularInvoiceTypeOptions = invoiceTypeOptions.filter(item => item.value !== managementFeeValue);

export default function AddEditAdditionalTax({ modeType, getResponseBack, onToggleModal, addEditAdditionalTax, params, usedTaxNames = [] }) {
    const [data, setData] = useState(addEditAdditionalTax?.mode === 'add' ? { invoice_types: [] } : { ...addEditAdditionalTax?.data, invoice_types: addEditAdditionalTax?.data?.invoice_types || [] });
    const [error, setError] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [dropDownLoader, setDropDownLoader] = useState(false)
    const [additonalTaxApi, setAdditionalTaxApi] = useState([]);
    const selectedTaxOption = typeof data?.name === 'object' ? data?.name : data?.tax_type_detail;
    const isNegativeTax = selectedTaxOption?.type?.value === 2;

    const onFieldChange = (key, value) => {
        if (key === 'invoice_types') {
            if (value === managementFeeValue) {
                if (isNegativeTax) { return }
                const currentValues = data?.invoice_types || [];
                const selecting = !currentValues.includes(managementFeeValue);
                setData({ ...data, [key]: selecting ? [managementFeeValue] : [], ...(selecting && { is_included_in_funds: true, is_applied_on_total: false }) })
            } else {
                let invArr = (data?.invoice_types || []).filter(item => item !== managementFeeValue)
                setData({ ...data, [key]: invArr.includes(value) ? invArr.filter(item => item !== value) : [...invArr, value] })
            }
        } else if (key === 'name') {
            const selectingNegativeTax = value?.type?.value === 2;
            setData({
                ...data,
                [key]: value,
                ...(selectingNegativeTax && { invoice_types: (data?.invoice_types || []).filter(item => item !== managementFeeValue) })
            })
        } else {
            setData({ ...data, [key]: value })
        }
    }

    const allInvoiceTypes = invoiceTypeOptions.map(i => i.value);
    const isManagementFeeSelected = data?.invoice_types?.includes(managementFeeValue);
    const hasRegularTypeSelected = (data?.invoice_types || []).some(v => v !== managementFeeValue);
    const isManagementFeeDisabled = modeType === "view" || isNegativeTax;

    const selectedTaxName = typeof data?.name === 'object' ? data?.name?.name : (data?.name || '');
    const filteredTaxOptions = (additonalTaxApi || []).filter((option) => {
        const isCurrentSelection = option?.name === selectedTaxName;
        const isUsed = (usedTaxNames || []).some(name => name === option?.name);
        return isCurrentSelection || !isUsed;
    });

    const onAddEditAdditionalTax = () => {
        let validateInput = {
            name: data?.name ? '' : 'Please enter Tax Name',
            tax_percentage: data?.tax_percentage ? '' : 'Please enter Tax percentage',
            invoice_types: data?.invoice_types?.length ? '' : 'Please select Invoice Type',
            order: data?.order ? '' : 'Please enter Sort Order',
            applicability: data?.is_included_in_funds || data?.is_applied_on_total ?'':'Please select any one applicability.'
        }
        if (Object.keys(validateInput).every(i => validateInput[i] === '')) {
            const taxType = typeof data?.name === 'object' ? data?.name?.id : data?.tax_type;
            const taxName = typeof data?.name === 'object' ? data?.name?.name : data?.name;
            let payload = {
                ...data,
                name: taxName,
                tax_type: taxType,
                tax_percentage: data?.tax_percentage,
                invoice_types: data?.invoice_types,
                order: data?.order,
                status: data?.status,
                is_included_in_funds: data?.is_included_in_funds,
                apply_on_total: data?.apply_on_total
            }
            setLoading(true)
            if(data?.id){
                globalPutService(`lease/${params?.leaseSlug}/additional-tax/${data?.slug}`, payload)
                 .then(response => {
                    setLoading(false)
                    if(checkApiStatus(response)){
                        onToggleModal()
                        getResponseBack()
                        enqueueSnackbar(response.data.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }});
                        trackActivity('Item Edited', { page_title: `Edit Additional Tax`, success_msg: response?.data?.message, item_id: data?.id, payload: payload, response: response?.data })
                    }else{
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }});
                        trackActivity('Item Edited', { page_title: `Edit Additional Tax`, error_msg: response?.data?.message, item_id: data?.id, payload: payload, response: response?.data })
                    }
                }) 
            }else{
                globalPostService(`lease/${params?.leaseSlug}/additional-tax`, payload)
                .then(response => {
                    setLoading(false)
                    if(checkApiStatus(response)){
                        onToggleModal()
                        getResponseBack()
                        enqueueSnackbar(response.data.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }});
                        trackActivity('Item Added', { page_title: `Add Additional Tax`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: payload, response: response?.data })
                    }else{
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }});
                        trackActivity('Item Added', { page_title: `Add Additional Tax`, error_msg: response?.data?.message, item_id: null, payload: payload, response: response?.data })
                    }
                })
            }
        } else {
            setError(validateInput)
            trackActivity(`Item ${modeType==='add'?'Added':'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Additional Tax`, error_msg:validateInput, })
        }

    }
    const onFocusChange = (key) => { setError({ ...error, [key]: '' }) }
    const handleItemClicked = () => {
        
    }
    const onSelectAllInvTypes = () => {
        const allSelected = allInvoiceTypes.every(type => data?.invoice_types?.includes(type));
        setData({ ...data, invoice_types: allSelected ? [] : [...allInvoiceTypes] });
    }

    const additionalTaxList = () => {
        setDropDownLoader(true)
        globalGetService(additionalTaxTypeApi(params))
            .then(response => {
                setDropDownLoader(false)
                if (checkApiStatus(response)) {
                    const list = response?.data?.data?.list || [];
                    setAdditionalTaxApi(list.map(item => ({ id: item?.id, name: item?.name, type: item?.type })));
                }
            })
    }

    useEffect(() => { 
        additionalTaxList() 
    }, []);

    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }

    return (
        <div>
            <Dialog
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='md'
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2, pl: 3 }} className='dialog-header'>
                    {addEditAdditionalTax?.mode === 'add' ? "Add Tax Configuration" : modeType === "view" ? 'View Tax Configuration': 'Edit Tax Configuration'}
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Autocomplete
                                disabled={modeType === "view"}
                                disableClearable
                                disablePortal
                                loading={dropDownLoader}
                                options={filteredTaxOptions}
                                isOptionEqualToValue={(option, value) => option?.id === (value?.id ?? null) || option?.name === value?.name }
                                getOptionLabel={(option) => (typeof option === 'object' ? option?.name : option) || ""}
                                noOptionsText={dropDownLoader ? "Loading..." : "No Option Available"}
                                value={ typeof data?.name === 'object' ? data?.name : additonalTaxApi.find(opt => opt.name === data?.name) || (data?.name ? { id: data?.tax_type, name: data?.name } : null) }
                                onChange={(e, value) => onFieldChange("name", value)}
                                onFocus={() => onRestErrorKey("name")}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                                            <TextField {...params} label="Tax Name" margin="normal" size="small" required error={error?.name} helperText={error?.name || ""}
                                                slotProps={{
                                                    inputLabel: { shrink: true },
                                                    input: {
                                                        ...params?.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {modeType !== "view" && dropDownLoader && (<CircularProgress color="inherit" size={20} />)}
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        )
                                                    }
                                                }}
                                            />
                                        </Tooltip>
                                    );
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <TextField
                                disabled={modeType === "view"}
                                id="tax"
                                label="Tax Rate (%)"
                                variant="outlined"
                                size='small'
                                value={data?.tax_percentage ? data?.tax_percentage : ''}
                                onChange={(e) => { regexConstants.percentageStrictDecimal.test(e.target.value) || e.target.value === "" ? onFieldChange('tax_percentage', e.target.value.trimStart()) : e.preventDefault() }}
                                required
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 10 } }}
                                onFocus={() => onFocusChange("tax_percentage")}
                                error={error?.tax_percentage}
                                helperText={error?.tax_percentage || ''}
                            />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <div style={{ background: '#f0f4ff', borderRadius: '8px', padding: '12px 14px' }}>
                                <Typography style={{ fontSize: '13px', marginBottom: '8px' }}>
                                    Applicable Invoice Type *
                                </Typography>
                                <div style={{ marginBottom: '10px' }}>
                                    {!isManagementFeeSelected && invoiceTypeOptions.map(item =>
                                    (<Chip
                                        key={item.value}
                                        style={{ marginRight: "5px", cursor: modeType === 'view' ? 'default' : 'pointer' }}
                                        size='small'
                                        label={item?.label || '--'}
                                        variant={data?.invoice_types?.includes(item.value) ? 'filled' : 'outlined'}
                                        color='primary'
                                        onClick={(e) => { modeType === 'view' ? e.preventDefault() : onFieldChange('invoice_types', item?.value); onFocusChange("invoice_types") }}
                                        disabled={modeType === "view"}
                                    />)
                                    )}
                                    {modeType === "view" ? null : !isManagementFeeSelected && <div className='slct-al-txt' onClick={onSelectAllInvTypes}>
                                        {allInvoiceTypes.every(type => data?.invoice_types?.includes(type)) ? 'Deselect All' : 'Select All'}
                                    </div>}
                                    {!isManagementFeeSelected && !hasRegularTypeSelected && <Typography disabled={modeType === "view"} component="span" sx={{ mx: 1, fontWeight: 500 }} color="primary" > / </Typography>}
                                    {!hasRegularTypeSelected && (
                                        <Chip
                                            style={{ marginLeft: "5px", cursor: isManagementFeeDisabled ? 'default' : 'pointer' }}
                                            size='small'
                                            label='Management Fee'
                                            variant={isManagementFeeSelected ? 'filled' : 'outlined'}
                                            color='primary'
                                            onClick={(e) => { isManagementFeeDisabled ? e.preventDefault() : onFieldChange('invoice_types', managementFeeValue); onFocusChange("invoice_types"); }}
                                            disabled={isManagementFeeDisabled}
                                        />
                                    )}
                                </div>
                                {error?.invoice_types ? <div className="error-message"> Please select Invoice Type </div> : null}
                            </div>
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Autocomplete
                                disableClearable
                                disabled={modeType === "view"}
                                size="small"
                                value={{
                                    label: (data?.status ?? true) ? "Active" : "Inactive",
                                    value: data?.status ?? true
                                }}
                                // value={data?.status }
                                onChange={(e, value) => onFieldChange("status", value?.value)}
                                options={[{ label: "Active", value: true }, { label: "Inactive", value: false }]}
                                renderInput={(params) => (<TextField {...params} label=' Status' size="small" margin="normal" required InputLabelProps={{ shrink: true }} />)}
                            />
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <TextField
                                disabled={modeType === "view"}
                                id="order"
                                label="Sort Order"
                                variant="outlined"
                                size='small'
                                value={data?.order ? data?.order : ''}
                                onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) || e.target.value === "" ? onFieldChange('order', e.target.value.trimStart()) : e.preventDefault() }}
                                required
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 3 } }}
                                onFocus={() => onFocusChange("order")}
                                error={error?.order}
                                helperText={error?.order || ''}
                            />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <RadioGroup
                                row
                                value={data?.is_included_in_funds ? 'is_included_in_funds' : data?.is_applied_on_total ? 'is_applied_on_total' : ''}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    onFocusChange("applicability")
                                    setData(prev => ({
                                        ...prev,
                                        is_included_in_funds: val === 'is_included_in_funds',
                                        is_applied_on_total: val === 'is_applied_on_total',
                                    }));
                                }}
                            >
                                <FormControlLabel
                                    value="is_included_in_funds"
                                    control={<Radio disabled={modeType === "view"} size="small" />}
                                    label="Include in Item Level"
                                />
                                {!isManagementFeeSelected && <FormControlLabel
                                    value="is_applied_on_total"
                                    control={<Radio disabled={modeType === "view"} size="small" />}
                                    label="Include in Total"
                                />}
                            </RadioGroup>
                            {error?.applicability ? <div className="error-message"> Please select any one Applicability </div> : null}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button variant='outlined' disabled={isLoading} size='small' className="cancel-btn" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>
                        {modeType === "view" ? "Close" : "Cancel"}
                    </Button>
                    {modeType === "view" ? null : 
                    <Button size='small' variant='contained' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); onAddEditAdditionalTax() }}>
                        {isLoading ? <CircularProgress color='inherit' size={24} /> : "Save"}
                    </Button>}
                </DialogActions>

            </Dialog>
        </div>
    )
}
